import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import DTOViajeEstatusSecuencia from '../../../DTOs/Operaciones/DTOViajeEstatusSecuencia'
const OpViajesEstatusSecuencia: DTOViajeEstatusSecuencia[] = []
const initialState = { OpViajesEstatusSecuencia }

export const OpViajesEstatusSecuenciaSlice = createSlice({
  name: 'OpViajesEstatusSecuencia',
  initialState: initialState,
  reducers: {
    resetOpViajesEstatusSecuencia : (state, action: PayloadAction<string>) => {
      state.OpViajesEstatusSecuencia =  []
    },  
    populateOpViajesEstatusSecuencia : (state, action: PayloadAction<DTOViajeEstatusSecuencia[]>) => {
        action.payload.forEach(element => {
            const index = state.OpViajesEstatusSecuencia.findIndex(object => object.id === element.id)
            if (index<0) state.OpViajesEstatusSecuencia.push(element)
        })
    },
    updateOpViajesEstatusSecuencia : (state, action: PayloadAction<DTOViajeEstatusSecuencia[]>) => {
      action.payload.forEach(row => {
      const i = state.OpViajesEstatusSecuencia.findIndex(_element => _element.id === row.id);
      if (i > -1) state.OpViajesEstatusSecuencia[i] = row;
      else state.OpViajesEstatusSecuencia.push(row);
    })
    },
    deleteOpViajesEstatusSecuencia : (state, action: PayloadAction<number>) => {
      const newArr = state.OpViajesEstatusSecuencia.filter(data => data.id != action.payload);
      state.OpViajesEstatusSecuencia=newArr
    },
  },
})

export const { resetOpViajesEstatusSecuencia, populateOpViajesEstatusSecuencia, updateOpViajesEstatusSecuencia, deleteOpViajesEstatusSecuencia } = OpViajesEstatusSecuenciaSlice.actions;
export default OpViajesEstatusSecuenciaSlice.reducer;